export const CLI_KIT_VERSION = '3.56.1'
